export default __webpack_public_path__ + "static/indus-store-033361e4e19b0f87b0d46a0f6ea07da8.svg";